import { http, HttpResponse } from 'msw'

import { allEmailSettings } from 'app/mocks/data/settings/email'

import { api } from 'app/utils/constants'

export const getEmailSettings = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.settings.email.LIST}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)

        const client = searchParams.get('client')

        let results = []

        if (client) {
            results = allEmailSettings.filter(
                (emailSettings) => emailSettings.client.toString() === client,
            )
        }

        return HttpResponse.json({
            results,
        })
    },
)
